import {
  useConfigurableList,
  useAddConfigurableListItem,
  useUpdateConfigurableListItem,
  useDeleteConfigurableListItem,
} from '@/hooks/useConfigurableLists';
import StringListEditor from '../components/StringListEditor';

export default function ProjectTypesSettings() {
  const { data: items = [], isLoading } = useConfigurableList('project_type');
  const addMutation = useAddConfigurableListItem('project_type');
  const updateMutation = useUpdateConfigurableListItem('project_type');
  const deleteMutation = useDeleteConfigurableListItem('project_type');

  return (
    <StringListEditor
      title="Project Types"
      items={items.map((item) => ({ id: item.id, value: item.value }))}
      isLoading={isLoading}
      onAdd={(value) => addMutation.mutate(value)}
      onUpdate={(id, value) => updateMutation.mutate({ id, value })}
      onDelete={(id) => deleteMutation.mutate(id)}
      isAdding={addMutation.isPending}
      isUpdating={updateMutation.isPending}
      isDeleting={deleteMutation.isPending}
    />
  );
}
